import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MerchantBulkRepository } from '@app/domain/ports/tpv/merchant-bulk.repository';
import { TpvBulkMerchantsResult } from '@app/domain/models/tpv/merchant-bulk.model';
import { TpvReportFile } from '@app/domain/models/tpv/tpv-report.model';
import { TpvReportFileDto } from '@app/data/dtos/tpv/tpv-report.dto';
import { tpvUrl } from '@app/data/tpv/tpv-api.config';
import { TpvEnvelope, unwrapTpv } from '@app/data/tpv/tpv-envelope';

/**
 * Alta masiva de comercios + plantilla (`api/v1/tpv/merchants/bulk/`, §4 y §5).
 * Auth y x-api-key vía interceptores estándar; `Idempotency-Key` opcional (el
 * micro NO deduplica por ella).
 */
@Injectable()
export class MerchantBulkRemoteDataSource extends MerchantBulkRepository {
  private readonly http = inject(HttpClient);

  override createBulk(
    merchants: unknown[],
    idempotencyKey?: string,
  ): Observable<TpvBulkMerchantsResult> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (idempotencyKey) {
      headers = headers.set('Idempotency-Key', idempotencyKey);
    }
    return this.http
      .post<TpvEnvelope<unknown>>(tpvUrl('merchants/bulk/'), merchants, { headers })
      .pipe(
        map((raw) => ({
          message: raw?.message ?? '',
          data: unwrapTpv<unknown>(raw),
        })),
      );
  }

  override getTemplate(): Observable<TpvReportFile> {
    return this.http
      .get<TpvEnvelope<TpvReportFileDto>>(tpvUrl('merchants/bulk/template/'))
      .pipe(
        map((raw) => {
          const dto = unwrapTpv<TpvReportFileDto>(raw);
          return {
            fileName: dto?.file_name?.trim() || 'layout.xlsx',
            fileBase64: dto?.file_base64 ?? '',
            fileSize: dto?.file_size ?? 0,
          };
        }),
      );
  }
}
